import React from "react";

import { IndividualApplication } from "IndividualApplication/types";

import { RadioGroup } from "Cobalt/RadioGroup";
import { Table, TR, TH, TD, HeaderTR } from "Cobalt/TableV2";

const tierLabels = {
  self_cost: "Just Me",
  spouse_cost: "Me and my Spouse",
  child_cost: "Me and my Children",
  family_cost: "My Whole Family",
};
const costToApplication = {
  self_cost: "ee_self",
  spouse_cost: "ee_spouse",
  child_cost: "ee_children",
  family_cost: "ee_family",
};

interface IndividualDependentEnrollmentTableProps {
  individualApplication: IndividualApplication;
  coverageSelected: string;
  onChange: Function;
}

const IndividualDependentEnrollmentTable = ({ individualApplication, coverageSelected, onChange }: IndividualDependentEnrollmentTableProps) => {
  if (!individualApplication) return <></>;

  const initialValues = {};
  const dependentEnrollment = individualApplication.dependentEnrollmentDental || individualApplication.dependentEnrollmentVision;

  Object.entries(costToApplication).forEach(([key, value]) => {
    initialValues[key] = dependentEnrollment == value ? "yes" : "no";
  });

  const coverageRow = (rowKey: string) => (
    <React.Fragment key={rowKey}>
      <TR>
        <TD>{tierLabels[rowKey]}</TD>
        <TD>
          <RadioGroup
            id={rowKey}
            name={rowKey}
            onChange={() => {
              onChange(rowKey);
            }}
            options={{ yes: "Yes", no: "No" }}
            value={rowKey == coverageSelected ? "yes" : "no"}
            inline
          />
        </TD>
      </TR>
    </React.Fragment>
  );

  return (
    <Table>
      <thead>
        <HeaderTR>
          <TH />
          <TH>Enroll In Coverage</TH>
        </HeaderTR>
      </thead>
      <tbody>
        {Object.keys(tierLabels).map((key) => {
          if (key == "self_cost") return coverageRow("self_cost");

          if (key == "spouse_cost" && individualApplication.individualHasSpouse) {
            return coverageRow("spouse_cost");
          }
          if (key == "child_cost" && individualApplication.individualHasChildren) {
            return coverageRow("child_cost");
          }
          if (key == "family_cost" && individualApplication.individualHasSpouse && individualApplication.individualHasChildren) {
            return coverageRow("family_cost");
          }
          return false;
        })}
      </tbody>
    </Table>
  );
};

export default IndividualDependentEnrollmentTable;
